import { supabase } from './api'

export const revalidate = 0

export async function getAllData() {
    const { data, error } = await supabase.from('applicationcheck').select();

    if (error) {
      throw new Error('Failed to fetch data')
    }
    return data;
  }

  export async function getDataWithCategory(category) {
    const { data, error } = await supabase.from('applicationcheck').select().eq('category', category).order('order', { ascending: true });

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function getIdData(id) {
    const { data, error } = await supabase.from('applicationcheck').select()
    .eq('id', id);
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function addData(adata) {
    const { data, error } = await supabase.from('applicationcheck').insert(adata).select();

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function updateData(udata) {
    console.log("udata",udata);
    const { data, error } = await supabase.from('applicationcheck').update(udata).eq('id', udata.id).select();

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function deleteIdData(id) {
    const { data, error } = await supabase.from('applicationcheck').delete()
    .eq('id', id);
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }
